const ThongKeTongHopTable = ({ dataTable }: any) => {
  return (
    <div style={{ display: "block", overflowX: "auto" }}>
      <table
        border={0}
        cellSpacing={0}
        className="table-thongke"
        style={{ width: "100%", fontSize: "13px" }}
      >
        <thead>
          <tr className="noBorder" hidden>
            <td align="center" colSpan={6}>
              <b>THỐNG KÊ TỔNG HỢP THEO NHÓM TƯ LIỆU</b>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid #ccc",
                textAlign: "center",
                verticalAlign: "middle",
                width: "40px"
              }}
            >
              <b>STT</b>
            </td>
            <td
              style={{
                border: "1px solid #ccc",
                textAlign: "center",
                verticalAlign: "middle",
                height: "50px",
                width: "190px"
              }}
            >
              <b>Tên nhóm tài liệu</b>
            </td>
            <td
              style={{
                border: "1px solid #ccc",
                textAlign: "center",
                verticalAlign: "middle",
                width: "100px"
              }}
            >
              <b>Tư liệu</b>
            </td>
            <td
              style={{
                border: "1px solid #ccc",
                textAlign: "center",
                verticalAlign: "middle",
                width: "100px"
              }}
            >
              <b>Hình ảnh</b>
            </td>
            <td
              style={{
                border: "1px solid #ccc",
                textAlign: "center",
                verticalAlign: "middle",
                width: "100px"
              }}
            >
              <b>Video</b>
            </td>
            <td
              style={{
                border: "1px solid #ccc",
                textAlign: "center",
                verticalAlign: "middle",
                width: "100px"
              }}
            >
              <b>Tổng</b>
            </td>
          </tr>
        </thead>
        <tbody>
          {dataTable &&
            dataTable.map((item: any, index: number) => (
              <tr key={index + 1}>
                <td
                  style={{
                    border: "1px solid #ccc",
                    textAlign: "center",
                    verticalAlign: "middle",
                    width: "40px"
                  }}
                >
                  {index + 1}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    textAlign: "left",
                    verticalAlign: "middle",
                    width: "40px"
                  }}
                >
                  {item.tenNhomTuLieu}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    textAlign: "right",
                    verticalAlign: "middle",
                    width: "40px"
                  }}
                >
                  {item.tuLieu}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    textAlign: "right",
                    verticalAlign: "middle",
                    width: "40px"
                  }}
                >
                  {item.hinhAnh}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    textAlign: "right",
                    verticalAlign: "middle",
                    width: "40px"
                  }}
                >
                  {item.video}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    textAlign: "right",
                    verticalAlign: "middle",
                    width: "40px"
                  }}
                >
                  {item.tong}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ThongKeTongHopTable;
